import React, { Component, Fragment } from "react";
import WithAccount, { AccountLoadStatus } from "assets/scripts/components/containers/secure/WithAccounts/WithAccount";
import { FormattedMessage, defineMessages } from "react-intl";
import Form from "assets/scripts/components/common/form/Form/Form";
import ProbateCaseFormGroups, { EMPTY_PROBATE_CASE, getErrors } from "assets/scripts/components/forms/ProbateCaseFormGroups/ProbateCaseFormGroups";
import { connect } from "react-redux";
import { backToAcct, addProbateCase } from "assets/scripts/domain/accts/acctsActions";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import MiscRepository from "assets/scripts/domain/misc/MiscRepository";
import track from "react-tracking";
const messages = defineMessages({
    thankYou: {
        id: "probateCase.thankYou",
        defaultMessage: "Thank you for submitting probate case information"
    },
    submit: {
        id: "probateCase.submit",
        defaultMessage: "Submit"
    },
    back: {
        id: "probateCase.back",
        defaultMessage: "Back"
    }
});
class ProbateCase extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: null
        };
        this._handleBack = () => this.props.onBackToAccount(this._getAcctId());
        this._handleChange = (value) => this.setState({ value });
        this._handleSubmit = () => {
            this.props.onSubmit(this._getAcctId(), this.state.value || EMPTY_PROBATE_CASE);
        };
    }
    componentDidMount() {
        MiscRepository.trackEvent({
            event: "CaseDataStart",
            payableId: this.props.params.id
        });
    }
    render() {
        return (<WithAccount acctId={this._getAcctId()}>
				{({ loading, error, acct }) => (<div className="wrapper wrapper_narrow">
						<div className="vr vr_x4">
							<h1 className="hdg js-pageHeader">
								<FormattedMessage id="probateCase.header" defaultMessage="Probate Case Information"/>
							</h1>
						</div>

						<AccountLoadStatus loading={loading} error={error}/>

						<StatusMessage isActive={!loading && acct != null && acct.probateCaseAccount.probateCase != null} isSuccess customMessage={messages.thankYou}/>

						{!loading && acct != null && this._renderForm(acct.probateCaseAccount)}
					</div>)}
			</WithAccount>);
    }
    _renderForm(acct) {
        const { props } = this;
        const alreadySubmitted = acct.probateCase != null;
        const probateCase = acct.probateCase || this.state.value || EMPTY_PROBATE_CASE;
        const { globalError, backendErrors } = props.fieldErrors;
        const errors = !alreadySubmitted ? getErrors(probateCase, true) : {
            caseNumber: null,
            state: null,
            county: null,
            petitionDate: null,
            caseType: null,
            dod: null,
            dob: null
        };
        const isValid = Object.values(errors).every(it => it == null);
        return (<Fragment>
				<div className="vr vr_x4">
					<Form isBusy={props.isSaving} isValid={isValid} onSubmit={alreadySubmitted ? this._handleBack : this._handleSubmit} submitLabel={alreadySubmitted ? messages.back : messages.submit} disabled={alreadySubmitted} error={globalError}>
						<ProbateCaseFormGroups probateCase={probateCase} onChange={this._handleChange} errors={errors} backendErrors={backendErrors} forceRequired/>
					</Form>
				</div>
				<StatusMessage isLoad isActive={this.props.isSaving}/>
			</Fragment>);
    }
    _getAcctId() {
        return parseInt(this.props.params.id, 10);
    }
}
export default track({ page: "ProbateCase" }, { dispatchOnMount: true })(connect((state) => state.accts.probateCase, {
    onSubmit: addProbateCase,
    onBackToAccount: backToAcct
})(ProbateCase));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/ProbateCase/ProbateCase.tsx